export const CSR_ACTIONS = {
  TRANSACT_AS_GUEST: 'transactAsAGuest',
  BUY_ON_BEHALF: 'buyOnBehalf',
  MANAGE_ACCOUNT: 'manageAccount'
};
